import React, { useState } from "react";
import Request from "../../utils/Request";
import RequestV2 from "../../api/RequestV2";
import { ButtonOutline } from "../styledConstants";
import jsPDF from "jspdf";
import "jspdf-autotable";
import IconDownload from "../../assets/images/IconDownload";
import { extractExportRows } from "./exportUtils";

const PdfDown = ({ tableHeader, getTableBody, url, params, heading, fileName, width = 800, method = "post", type = "", useV2 = false }) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const getUserList = () => {
    const successHandler = (res) => {
      const extracted = extractExportRows(res, { method, useV2 });

      const rows =
        extracted?.[0]?.metaInfo?.data ||
        extracted ||
        res?.metaInfo?.data ||
        [];
      if (rows.length > 0) {
        const tableBody = getTableBody(rows);
        generatePDF(tableBody);
      }
      // Re-enable button once PDF generation is triggered.
      setIsDisabled(false);
    };

    const errorHandler = () => {
      // On failure, also re-enable so user can retry quickly.
      setIsDisabled(false);
    };
    const RequestClass = useV2 ? RequestV2 : Request;
    const api = new RequestClass("", successHandler, errorHandler);
    if (method === "post") {
      api.post(url, params);
    } else {
      api.get(url);
    }
  };

  const handleClick = () => {
    if (isDisabled) return; // prevent multiple clicks if already disabled

    setIsDisabled(true); // disable the button
    getUserList();
  };

  const generatePDF = (tableBody) => {
    const doc = new jsPDF("l", "px", [width, 600]);

    if (heading) {
      doc.text(heading, doc.internal.pageSize.width / 2, 20, { align: 'center' });
    }

    doc.autoTable({
      head: tableHeader,
      body: tableBody,
      startY: 25,
      styles: { overflow: "ellipsize", cellWidth: "wrap" },
      columnStyles: { text: { cellWidth: "auto" } },
    });

    doc.save((fileName || "document") + ".pdf");
  };

  return (
    <ButtonOutline
      className="flex flex-center"
      primary
      rg
      onClick={handleClick}
      disabled={isDisabled} // disable the button
      style={{ cursor: isDisabled ? "not-allowed" : "pointer", opacity: isDisabled ? 0.6 : 1 }}
    >
      <IconDownload className="mr8" /> {isDisabled ? "Please wait..." : "PDF"}
    </ButtonOutline>
  );
};

export default PdfDown;
